import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.lightGrey,
  fontColor: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default promoBanner;